import { Review } from '../types'

export const mockReviews: Review[] = [
  {
    id: 'trusted-review-1',
    vendorId: 'vendor-1',
    userId: 'trusted-tester-1',
    userName: 'TrustedTester_Mike',
    rating: 5,
    title: 'Comprehensive 7OH Analysis - Lab Verified Excellence',
    content: 'As a trusted community tester, I conducted extensive testing of their premium 7OH tablets. Lab analysis confirms 99.2% purity with consistent 10mg dosing across all tablets tested. Effects profile shows excellent bioavailability with onset at 12-15 minutes and duration of 7-8 hours. No adulterants detected. Packaging maintains potency excellently. This vendor sets the gold standard for 7OH products.',
    pros: ['Lab-verified purity', 'Consistent dosing', 'Professional packaging', 'Excellent customer service', 'Fast shipping'],
    cons: ['Premium pricing', 'Limited stock'],
    wouldRecommend: true,
    productsPurchased: ['7OH Tablets 10mg (100ct)', '7OH Powder 5% (5g)'],
    dateCreated: new Date('2024-01-25'),
    helpfulVotes: 47,
    unhelpfulVotes: 0,
    verified: true,
    categoryRatings: {
      quality: 5,
      value: 4,
      shipping: 5,
      customerService: 5,
      communication: 5,
      website: 5
    },
    experienceDetails: {
      orderSize: 'large',
      orderValue: 189.99,
      effectsExperienced: ['Deep Relaxation', 'Euphoria', 'Pain Relief', 'Mood Enhancement'],
      dosageUsed: '10mg',
      consumptionMethod: 'tablet',
      purposeOfUse: 'testing',
      firstTimeCustomer: false,
      returningCustomer: true,
      comparedToOtherVendors: true,
      wouldOrderAgain: true
    },
    isEdited: false,
    reportCount: 0,
    isHidden: false,
    orderNumber: 'ORD-TRUSTED-001',
    purchaseDate: new Date('2024-01-20'),
    userExperience: 'expert',
    tags: ['Trusted Tester', 'Lab Verified', 'Expert Review', 'Premium Quality']
  },
  {
    id: 'trusted-review-2',
    vendorId: 'vendor-2',
    userId: 'trusted-tester-2',
    userName: 'TrustedTester_Sarah',
    rating: 4,
    title: 'MIT Extract Deep Dive - Solid Mid-Tier Option',
    content: 'Comprehensive analysis of their MIT 45% extract reveals good quality control with actual alkaloid content testing at 43.8% - close to advertised. Clean extraction process evident with minimal plant matter residue. Effects are well-balanced for both new and experienced users. Pricing is competitive for the quality provided. Minor points deducted for slightly slower customer service response times.',
    pros: ['Accurate alkaloid content', 'Clean extraction', 'Good value', 'Consistent quality', 'Detailed lab reports'],
    cons: ['Customer service could be faster', 'Limited payment options'],
    wouldRecommend: true,
    productsPurchased: ['MIT Extract 45% (3g)', 'Traditional Red Bali (100g)'],
    dateCreated: new Date('2024-01-28'),
    helpfulVotes: 32,
    unhelpfulVotes: 1,
    verified: true,
    categoryRatings: {
      quality: 4,
      value: 5,
      shipping: 4,
      customerService: 3,
      communication: 3,
      website: 4
    },
    experienceDetails: {
      orderSize: 'medium',
      orderValue: 67.50,
      effectsExperienced: ['Pain Relief', 'Focus Enhancement', 'Mild Euphoria'],
      dosageUsed: '25mg',
      consumptionMethod: 'powder',
      purposeOfUse: 'testing',
      firstTimeCustomer: false,
      returningCustomer: true,
      comparedToOtherVendors: true,
      wouldOrderAgain: true
    },
    isEdited: false,
    reportCount: 0,
    isHidden: false,
    orderNumber: 'ORD-TRUSTED-002',
    purchaseDate: new Date('2024-01-23'),
    userExperience: 'expert',
    tags: ['Trusted Tester', 'MIT Extract', 'Value Pick', 'Expert Analysis']
  },
  {
    id: 'review-1',
    vendorId: 'vendor-1',
    userId: 'user-1',
    userName: 'KratomUser123',
    rating: 5,
    title: 'Excellent 7OH Tablets - Fast Shipping',
    content: 'Ordered their 7OH tablets and was impressed with the quality. Effects were exactly as described and shipping was super fast. Will definitely order again. The tablets were precisely dosed at 10mg per tablet and had clear lab results. Effects kicked in within 15 minutes and lasted about 6-8 hours. Perfect for evening relaxation after work.',
    pros: ['Fast shipping', 'Great quality', 'Accurate potency', 'Good packaging'],
    cons: ['Slightly pricey'],
    wouldRecommend: true,
    productsPurchased: ['7OH Tablets 10mg (50ct)'],
    dateCreated: new Date('2024-01-15'),
    helpfulVotes: 12,
    unhelpfulVotes: 1,
    verified: true,
    categoryRatings: {
      quality: 5,
      value: 4,
      shipping: 5,
      customerService: 5,
      communication: 5,
      website: 4
    },
    experienceDetails: {
      orderSize: 'medium',
      orderValue: 89.99,
      effectsExperienced: ['Deep Relaxation', 'Euphoria', 'Mood Enhancement'],
      dosageUsed: '10mg',
      consumptionMethod: 'tablet',
      purposeOfUse: 'wellness',
      firstTimeCustomer: true,
      returningCustomer: false,
      comparedToOtherVendors: true,
      wouldOrderAgain: true
    },
    isEdited: false,
    reportCount: 0,
    isHidden: false,
    orderNumber: 'ORD-12345',
    purchaseDate: new Date('2024-01-10'),
    userExperience: 'intermediate',
    tags: ['Fast Shipping', 'Great Quality', 'First Time Order']
  },
  {
    id: 'review-2', 
    vendorId: 'vendor-1',
    userId: 'user-2',
    userName: 'PlantLover88',
    rating: 4,
    title: 'Good vendor, had one issue with order',
    content: 'Generally happy with this vendor. Had one order arrive late but customer service was responsive and made it right. Product quality is consistent. The 7OH powder was particularly good - nice balance of potency and clean effects. MIT extract was a bit weaker than expected but still decent.',
    pros: ['Consistent quality', 'Responsive customer service', 'Lab testing available'],
    cons: ['Occasional shipping delays', 'Limited extract variety'],
    wouldRecommend: true,
    productsPurchased: ['7OH Powder 5% (2g)', 'MIT Extract 45% (1g)'],
    dateCreated: new Date('2024-01-20'),
    helpfulVotes: 8,
    unhelpfulVotes: 2,
    verified: true,
    categoryRatings: {
      quality: 4,
      value: 4,
      shipping: 3,
      customerService: 5,
      communication: 4,
      website: 4
    },
    experienceDetails: {
      orderSize: 'small',
      orderValue: 45.50,
      effectsExperienced: ['Energy', 'Focus', 'Clean Euphoria'],
      dosageUsed: '50mg',
      consumptionMethod: 'sublingual',
      purposeOfUse: 'wellness',
      firstTimeCustomer: false,
      returningCustomer: true,
      comparedToOtherVendors: true,
      wouldOrderAgain: true
    },
    vendorResponse: {
      id: 'response-1',
      vendorId: 'vendor-1',
      vendorName: 'Premium Kratom Co',
      response: 'Thank you for your feedback! We apologize for the shipping delay and are working to improve our logistics. We appreciate your patience and understanding.',
      datePosted: new Date('2024-01-22'),
      isOfficial: true
    },
    isEdited: false,
    reportCount: 0,
    isHidden: false,
    orderNumber: 'ORD-67890',
    purchaseDate: new Date('2024-01-15'),
    userExperience: 'experienced',
    tags: ['Responsive Support', 'Returning Customer', 'Good Value']
  },
  {
    id: 'review-3',
    vendorId: 'vendor-2',
    userId: 'user-3', 
    userName: 'NaturalHealing',
    rating: 5,
    title: 'Love the educational approach',
    content: 'This vendor really stands out for their educational content and responsible selling practices. The 7OH powder is fantastic and their dosage guides helped me find the right amount. Their commitment to lab testing and quality control really resonates with me. The packaging is also tamper-evident which I appreciate.',
    pros: ['Educational resources', 'Lab verified products', 'Great customer education', 'High quality extracts'],
    cons: ['Higher prices than some competitors'],
    wouldRecommend: true,
    productsPurchased: ['7OH Powder 7.5% (5g)'],
    dateCreated: new Date('2024-01-10'),
    helpfulVotes: 15,
    unhelpfulVotes: 0,
    verified: true,
    categoryRatings: {
      quality: 5,
      value: 3,
      shipping: 4,
      customerService: 5,
      communication: 5,
      website: 5
    },
    experienceDetails: {
      orderSize: 'large',
      orderValue: 189.99,
      effectsExperienced: ['Deep Relaxation', 'Euphoria', 'Mood Enhancement', 'Sleep Aid'],
      dosageUsed: '75mg',
      consumptionMethod: 'measured powder',
      purposeOfUse: 'wellness',
      firstTimeCustomer: true,
      returningCustomer: false,
      comparedToOtherVendors: false,
      wouldOrderAgain: true
    },
    isEdited: false,
    reportCount: 0,
    isHidden: false,
    userExperience: 'beginner',
    tags: ['Educational', 'Sustainable', 'High Quality', 'Eco-Friendly']
  },
  {
    id: 'review-4',
    vendorId: 'vendor-4',
    userId: 'user-4',
    userName: 'ResearchUser',
    rating: 5,
    title: 'Best for experienced users - detailed testing',
    content: 'If you are serious about extracts and want to know exactly what you are getting, this is your vendor. Their alkaloid profiles and testing data is unmatched. The MIT extract tested at 47.2% mitragynine which is exactly what they stated. Perfect for my research needs and the effects were precisely what I expected based on the profile.',
    pros: ['Detailed lab testing', 'Alkaloid profiles', 'Research-grade quality', 'Pure extracts'],
    cons: ['Not beginner-friendly', 'Limited availability', 'Premium pricing'],
    wouldRecommend: true,
    productsPurchased: ['MIT Extract 47% (2g)'],
    dateCreated: new Date('2024-01-25'),
    helpfulVotes: 22,
    unhelpfulVotes: 1,
    verified: true,
    categoryRatings: {
      quality: 5,
      value: 3,
      shipping: 4,
      customerService: 4,
      communication: 5,
      website: 5
    },
    experienceDetails: {
      orderSize: 'small',
      orderValue: 149.99,
      effectsExperienced: ['Pain Relief', 'Deep Relaxation'],
      dosageUsed: '25mg',
      consumptionMethod: 'capsules',
      purposeOfUse: 'research',
      firstTimeCustomer: false,
      returningCustomer: true,
      comparedToOtherVendors: true,
      wouldOrderAgain: true
    },
    isEdited: false,
    reportCount: 0,
    isHidden: false,
    orderNumber: 'RES-2024-001',
    purchaseDate: new Date('2024-01-20'),
    userExperience: 'expert',
    tags: ['Lab Tested', 'Research Grade', 'Expert Level', 'Alkaloid Profiles']
  },
  {
    id: 'review-5',
    vendorId: 'vendor-5',
    userId: 'user-5',
    userName: 'BudgetBuyer',
    rating: 4,
    title: 'Great value for daily users',
    content: 'Perfect for those of us who use extracts daily and need good quality at reasonable prices. Bulk pricing is excellent and quality is reliable. The 7OH powder bulk packs are my go-to for daily use. Not the most potent but very consistent and the price can\'t be beat for the quality you get.',
    pros: ['Great bulk pricing', 'Reliable quality', 'Frequent sales', 'Good for daily use'],
    cons: ['Basic packaging', 'Limited premium options'],
    wouldRecommend: true,
    productsPurchased: ['7OH Powder 4% (25g bulk)'],
    dateCreated: new Date('2024-01-18'),
    helpfulVotes: 9,
    unhelpfulVotes: 3,
    verified: true,
    categoryRatings: {
      quality: 4,
      value: 5,
      shipping: 4,
      customerService: 3,
      communication: 3,
      website: 3
    },
    experienceDetails: {
      orderSize: 'bulk',
      orderValue: 299.99,
      effectsExperienced: ['Energy', 'Focus', 'Motivation'],
      dosageUsed: '40mg',
      consumptionMethod: 'measured powder',
      purposeOfUse: 'wellness',
      firstTimeCustomer: false,
      returningCustomer: true,
      comparedToOtherVendors: true,
      wouldOrderAgain: true
    },
    isEdited: false,
    reportCount: 0,
    isHidden: false,
    orderNumber: 'BULK-789',
    purchaseDate: new Date('2024-01-12'),
    userExperience: 'experienced',
    tags: ['Bulk Order', 'Great Value', 'Daily Use', 'Consistent Effects']
  }
]